import { SkBar } from '../widgets/skeletons';

/**
 * TranscriptHydrateSkeleton (ANA-371) — placeholder shown while a resumed
 * conversation's transcript silently hydrates (`GET /:id/turns`), so the surface
 * never flashes a blank thread before history lands. Purely decorative; mirrors
 * the alternating assistant/user bubble rhythm of a real thread.
 */
export function TranscriptHydrateSkeleton({ className }: { className?: string }) {
  return (
    <div
      data-testid="transcript-hydrate-skeleton"
      aria-hidden="true"
      className={`flex flex-1 flex-col gap-4 overflow-hidden p-4${className ? ` ${className}` : ''}`}
    >
      {/* assistant */}
      <div className="flex max-w-[80%] flex-col gap-2 self-start">
        <SkBar width="220px" height="0.75rem" />
        <SkBar width="180px" height="0.75rem" />
      </div>
      {/* user */}
      <div className="flex max-w-[70%] flex-col gap-2 self-end">
        <SkBar width="150px" height="0.75rem" />
      </div>
      {/* assistant */}
      <div className="flex max-w-[80%] flex-col gap-2 self-start">
        <SkBar width="240px" height="0.75rem" />
        <SkBar width="200px" height="0.75rem" />
        <SkBar width="120px" height="0.75rem" />
      </div>
    </div>
  );
}
